import { render, staticRenderFns } from "./DeleteSuperBom.vue?vue&type=template&id=2e88de6e"
import script from "./DeleteSuperBom.vue?vue&type=script&lang=js"
export * from "./DeleteSuperBom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports